import { useShallow } from "zustand/shallow";
import { useUserStore } from "../../stores";

export const useSession = () => {
  return useUserStore(
    useShallow((state) => ({
      session: state.session,
      setSession: state.setSession,
      isAuthenticated: state.isAuthenticated,
      setIsAuthenticated: state.setIsAuthenticated,
    }))
  );
};
